module.exports = __webpack_public_path__ + "img/icon-warning-yellow-New.e87c4838.svg";